import { render, staticRenderFns } from "./companyClaimsSetups.vue?vue&type=template&id=f8dd604a"
import script from "./companyClaimsSetups.vue?vue&type=script&lang=js"
export * from "./companyClaimsSetups.vue?vue&type=script&lang=js"
import style0 from "./companyClaimsSetups.vue?vue&type=style&index=0&id=f8dd604a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports